const createLog = (guid, authorization, game, command) => {
	return {
		guid,
		authorization,
		game,
		command,
	}
}

export default createLog